const IMAGE_BASE_PATH = process.env.REACT_APP_IMAGE_BASE_PATH;

const images = {
    redLogoImage: `${IMAGE_BASE_PATH}/uploading_08_05_55/betassist-h.png`,
    firstSliderBackgroundImg: `${IMAGE_BASE_PATH}/uploading_08_05_55/football-bg.jpg`,
    ligSliderBackgroundImage : `${IMAGE_BASE_PATH}/uploading_23_07_06/soccer_ball_variant_1688634810196.png`,
    defaultHome: `${IMAGE_BASE_PATH}/uploading_06_09_50/defaulthome.png`,
    defaultAway: `${IMAGE_BASE_PATH}/uploading_06_09_50/defaultaway.png`,
    trFlag: `${IMAGE_BASE_PATH}/flags/tr.png`,
    enFlag: `${IMAGE_BASE_PATH}/flags/uk.png`
}

export default images